/* ==========================================================================
Pricing
========================================================================== */
/*jshint esversion: 6 */
"use strict";

function initPricing() {
    $(".pricing-tabs .tab-item").on("click", function () {
        var target = $(this).attr("data-tab");
        $(this).siblings(".tab-item").removeClass("is-active");
        $(this).addClass("is-active");
        $(".pricing-container").removeClass("is-active");
        $("#" + target).addClass("is-active");
        // Manually refresh positioning of slick
        $(".feature-carousel").slick("setPosition");
    });
}

function initTabbedPricing() {
    if ($(".header-pricing").length) {
        $(".pricing-picker span").on("click", function () {
            $(".pricing-picker span.is-active").removeClass("is-active");
            $(this).addClass("is-active");
        });

        $("#show-monthly").on("click", function () {
            $(".per-year").addClass("is-hidden");
            $(".per-month").removeClass("is-hidden");
        });

        $("#show-annualy").on("click", function () {
            $(".per-month").addClass("is-hidden");
            $(".per-year").removeClass("is-hidden");
        });
    }
}

function initFreelancerPricing() {
    /*$(".plan-controls span").on("click", function () {
        $(".plan-controls span").toggleClass("is-active");
    });*/

    $(".period-select span").on("click", function () {
        $(".period-select span").toggleClass("is-active");
        $(".month-price, .year-price").toggleClass("is-hidden");
    });

    $("#show-freelance").on("click", function () {
        $("#freelance-pricing").removeClass("is-hidden");
        $("#business-pricing").addClass("is-hidden");
    });

    $("#show-lxc").on("click", function () {
        $("#lxc-pricing").removeClass("is-hidden");
        $("#kvm-pricing").addClass("is-hidden");
        $("#dedicated-pricing").addClass("is-hidden");
        $("#show-lxc").addClass("is-active");
        $("#show-kvm").removeClass("is-active");
        $("#show-dedicated").removeClass("is-active");
    });

    $("#show-kvm").on("click", function () {
        $("#lxc-pricing").addClass("is-hidden");
        $("#kvm-pricing").removeClass("is-hidden");
        $("#dedicated-pricing").addClass("is-hidden");
        $("#show-lxc").removeClass("is-active");
        $("#show-kvm").addClass("is-active");
        $("#show-dedicated").removeClass("is-active");
    });

    $("#show-dedicated").on("click", function () {
        $("#kvm-pricing").addClass("is-hidden");
        $("#lxc-pricing").addClass("is-hidden");
        $("#dedicated-pricing").removeClass("is-hidden");
        $("#show-lxc").removeClass("is-active");
        $("#show-kvm").removeClass("is-active");
        $("#show-dedicated").addClass("is-active");
    });

    $("#show-business").on("click", function () {
        $("#business-pricing").removeClass("is-hidden");
        $("#freelance-pricing").addClass("is-hidden");
    });
}

function initBoxedPricing() {
    if ($("#price-switch").length) {
        $("#price-switch").on("click", function () {
            $(".by-year, .by-month").toggleClass("is-active");
            $(".condensed-plan").toggleClass("is-switched");
        });
    }
}

function initSwitchPricing() {
    if ($(".switch-pricing-wrapper").length) {
        $(".pricing-switcher input").on("change", function () {
            $(".plan-price").toggleClass("is-active");
        });
    }
}

function initOnePagePricing() {
    $(".combo-button .button").on("click", function () {
        $(".combo-button .button.is-active").removeClass("is-active");
        $(this).addClass("is-active");
        $(".plan-price, .price-per").toggleClass("is-hidden");
    });
}

function initDedicatedPricing(categories) {
    categories.forEach(function (category, i) {
        $("#show-dedicated-" + category.id).on("click", function () {
            $(`#dedicated-${category.id}-pricing`).removeClass("is-hidden");
            $("#show-dedicated-" + category.id).addClass("is-active");
            categories.forEach(function (c, i) {
                if(c.id !== category.id) {
                    $(`#dedicated-${c.id}-pricing`).addClass("is-hidden");
                    $("#show-dedicated-" + c.id).removeClass("is-active");
                }
            });
        });
    });
}

function initPricingPage() {
    $.getJSON("assets/data/templates.json", function (data) {
        var lxcItems = [];
        $.each(data.lxc, function (key, val) {
            lxcItems.push(`<div class="column is-4">
                            <!-- Pricing table -->
                            <div class="flex-card header-pricing-card primary card-hover">
                                <h3 class="plan-name">${val.name}</h3>
                                <div class="pricing-card-body">
                                    <div
                                            class="plan-price per-month animated preFadeInUp fadeInUp"
                                    >
                                        <small>€</small> ${val.price * 0.01} <small data-i18n="pricing.card.perMonth">/ month</small>
                                    </div>
                                    <div
                                            class="
                      plan-price
                      per-year
                      is-hidden
                      animated
                      preFadeInUp
                      fadeInUp
                    "
                                    >
                                        <small>$</small> ${val.price * 0.12} <small>/ year</small>
                                    </div>
                                    <ul class="plan-features">
                                        <li><span class="feature-count-text" data-i18n="pricing.card.cpuCores" data-i18n-options='{"count":${val.cores}}'>${val.cores} CPU Cores</span></li>
                                        <li><span class="feature-count-text">${val.disk} GB Disk</span></li>
                                        <li>
                                            <span class="feature-count-text">${val.ram} GiB RAM</span>
                                        </li>
                                    </ul>
                                    <br>
                                </div>
                            </div>
                        </div>`);
        });

        var kvmItems = [];
        $.each(data.kvm, function (key, val) {
            kvmItems.push(`<div class="column is-4">
                            <!-- Pricing table -->
                            <div class="flex-card header-pricing-card primary hover-inset">
                                <h3 class="plan-name">${val.name}</h3>
                                <div class="pricing-card-body">
                                    <div
                                            class="plan-price per-month animated preFadeInUp fadeInUp"
                                    >
                                        <small>€</small> ${val.price * 0.01} <small>/ month</small>
                                    </div>
                                    <div
                                            class="
                      plan-price
                      per-year
                      is-hidden
                      animated
                      preFadeInUp
                      fadeInUp
                    "
                                    >
                                        <small>$</small> ${val.price * 0.12} <small>/ year</small>
                                    </div>
                                    <ul class="plan-features">
                                        <li><span class="feature-count-text">${val.cores} CPU Cores</span></li>
                                        <li><span class="feature-count-text">${val.disk} GB Disk</span></li>
                                        <li>
                                            <span class="feature-count-text">${val.ram} GiB RAM</span>
                                        </li>
                                    </ul>
                                    <br>
                                </div>
                            </div>
                        </div>`);
        });

        var dedicatedItems = [];
        $.each(data.dedicated.categories, function (i, category) {
            dedicatedItems.push(`<div id="dedicated-${category.id}-pricing" class="${i === 0 ? "" : "is-hidden"} row is-vcentered">
${category.items.map(function (val, localIndex) {
    var key = "" + category.id + "" + localIndex;
                return `
<div class="column is-4">
<form>
                            <!-- Pricing table -->
                            <div class="flex-card header-pricing-card accent card-hover">
                                <h3 class="plan-name">${val.name}</h3>
                                <div class="pricing-card-body">
                                    <div
                                            class="plan-price per-month animated preFadeInUp fadeInUp"
                                    >
                                        <small>€</small> <output id="dedi${key}:monthPrice">${val.price * 0.01}</output> <small>/ month</small>
                                    </div>
                                    <div
                                            class="
                      plan-price
                      per-year
                      is-hidden
                      animated
                      preFadeInUp
                      fadeInUp
                    "
                                    >
                                        <small>$</small> <output id="dedi${key}:yearPrice">${val.price * 0.12}</output> <small>/ year</small>
                                    </div>
                                    <ul class="plan-features">
                                        <li><span class="feature-count-text">${val.cpu.count} x ${val.cpu.brand} ${val.cpu.name}</span><div data-i18n="pricing.card.coresAndClock" data-i18n-options='{"cores":${val.cpu.cores},"baseClock":"${val.cpu.clock.base / 1000} GHz","turboClock":"${val.cpu.clock.turbo / 1000} GHz"}'></div></li>
                                        <li>
                                        <span class="feature-count-text"><output id="dedi${key}:ram">${val.ram.value}</output> GB ${val.ram.type} RAM</span>
                                        
      <div class="component-block">
        <div class="field">
          <div class="control">
            <input id="dedi${key}:ramSlider" name="ram"
              id="sliderWithValue"
              class="slider has-output-tooltip is-fullwidth"
              min="0"
              max="${category.upgrades.ram.length - 1}"
              value="1"
              step="1"
              type="range"
            />
          </div>
        </div>
      </div>
                                        </li>
                                        ${val.disks.map(function (d) {
                    return `<li><span class="feature-count-text">${d.size} GB ${d.type}</span></li>`;
                }).join('')}
                                        <li><div class="field">
                  <div class="control">
                    <select
                    id="dedi${key}:linkSelect"
                      class="chosen-select"
                      data-placeholder="Project type"
                    >
                      ${data.dedicatedLinks.map(function (d, i) {
                    return `<option label="${d.name}">${i}</option>`;
                }).join('')}
                    </select>
                  </div>
                </div></li>
                <li><div class="field">
                  <div class="control">
                    <select
                    id="dedi${key}:ddosSelect"
                      class="chosen-select"
                      data-placeholder="Project type"
                    >
                      <option label="Standard DDoS-Protection">standard</option>
                      <option label="Premium DDoS-Protection">premium</option>
                    </select>
                  </div>
                </div></li>
                                    </ul>
                                    <br>
                                </div>
                            </div>
      </form>
                        </div>`;
            }).join('')}</div>`);
        });

        $(".lxc-pricing-list").append(lxcItems.join(''));

        $(".kvm-pricing-list").append(kvmItems.join(''));

        $(".dedicated-pricing-list").append(dedicatedItems.join(''));

        $(":root").localize();

        $.each(data.dedicated.categories, function (cIndex, category) {
            $.each(category.items, function (key, val) {
                key = `dedi${category.id}${key}`;
                document.getElementById(key + ":ramSlider").addEventListener("input", function (e) {
                    updateDediPrice(key, val, category, data);
                });
                document.getElementById(key + ":linkSelect").addEventListener("input", function (e) {
                    updateDediPrice(key, val, category, data);
                });
                document.getElementById(key + ":ddosSelect").addEventListener("input", function (e) {
                    updateDediPrice(key, val, category, data);
                });
            });
        });
        initDedicatedPricing(data.dedicated.categories);
    });
}

function updateDediPrice(key, val, category, data) {
    var ramExtra = document.getElementById(key + ":ramSlider").value;
    var ramValue = category.upgrades.ram[ramExtra].value;
    var link = data.dedicatedLinks[parseInt(document.getElementById(key + ":linkSelect").value)];
    var ddosPrice = document.getElementById(key + ":ddosSelect").value === 'standard' ? 0 : 2000;
    var price = val.price + category.upgrades.ram[ramExtra].price + link.price + ddosPrice;
    document.getElementById(key + ":ram").innerText = ramValue;
    document.getElementById(key + ":monthPrice").innerText = "" + (price * 0.01);
    document.getElementById(key + ":yearPrice").innerText = "" + (price * 0.12);
}
